import { useState } from 'react';
import { withProps } from 'recompose';
import { fetchUserNickname } from './actions';

export default withProps(({ nicknameRequestComplete, setNicknameRequestComplete }) => {
    const [error, setError] = useState();
    const [nicknameDetails, setNicknameDetails] = useState();
    if (!nicknameRequestComplete) {
        fetchUserNickname()
            .then(({ data }) => { setNicknameRequestComplete(true); setNicknameDetails(data); })
            .catch(({ data }) => { setNicknameRequestComplete(true); setError(data); });
    }
    return { nicknameDetails, error, nicknameRequestComplete };
});
